/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { JSONable } from "@irian-ro/abstract-resource";
import { RoutingSolutionViewModelNew } from "./shipment-group-solution-page/routing-solution-view.model";
import {CurrencyValueModel} from "./currency-value.model";

export class SolutionSegmentTrackingViewModel extends JSONable {

  uuid: string | undefined = undefined;

  solutionSegmentUuid: string | undefined = undefined;

  pickupCity: string | undefined = undefined;

  pickupCountry: string | undefined = undefined;

  deliveryCity: string | undefined = undefined;

  deliveryCountry: string | undefined = undefined;

  routingSolutionView: RoutingSolutionViewModelNew | undefined = undefined;

  cost: CurrencyValueModel | undefined = undefined;

  routingSolutionUuid: string | undefined = undefined;

  spRoutingSolutionUuid: string | undefined = undefined;

  vendorOfferUuid: string | undefined = undefined;

  customerOrderUuid: string | undefined = undefined;

  customerOrderStatus: string | undefined = undefined;

  cOrderStatusAchievedAt: string | undefined = undefined;

  vendorName: string | undefined = undefined;

  vendorSpUuid: string | undefined = undefined;

  previousSegmentUuid: string | undefined = undefined;

  isFirstSegmentInSolution: string | undefined = undefined;

  taskCount: number | undefined = undefined;
}
